import { Path, Svg } from '@react-pdf/renderer';
import React from 'react';

/**
 * A placeholder for a bottle image
 * @param {object} props
 * @param {number | string} [props.width]
 * @param {number | string} [props.height]
 * @param {string} [props.color="#efefefef"]
 * @param {boolean} [props.debug]
 * @param {import('@react-pdf/types').Style} [props.style]
 */
export default function BottleImagePlaceholder({
  width = 60,
  height = 200,
  color = '#efefef',
  style,
  ...rest
}) {
  return (
    <Svg style={[{ width, height }, style]} viewBox="0 0 18 58" {...rest}>
      <Path
        d="M5.5,16.3532395 L5.5,1.31625802 C5.5,0.589426762 6.18361702,0 7.02696808,0 L10.9741489,0 C11.816383,0 12.5,0.589426762 12.5,1.31625802 L12.5,16.3529794 C15.7322568,17.515152 18.000283,20.2384253 18,23.4125917 L18,27.6689208 L18,41.0546227 L18,55.367805 C18,56.8211466 16.616081,58 14.9085308,58 L3.09260074,58 C1.38505061,58 0,56.8211466 0,55.367805 L0,41.0546227 L0,27.6689208 L0,23.4125917 C0,20.2384621 2.26833682,17.5155083 5.5,16.3532395 Z"
        fill={color}
      ></Path>
    </Svg>
  );
}
